import React from 'react'
import { usePermissionChecker } from '@/hooks/usePermissionChecker'

export function withPermissions () {
  return function (Component) { // decorator
    return function (props) { // wrapper component
      return <Component {...props} isGranted={usePermissionChecker()} />
    }
  }
}



// WEBPACK FOOTER //
// ./src/decorators/withPermissions.js